import React, { useContext } from 'react'
import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import BodyText from 'LuxKit/Typography/BodyText'
import styled from 'styled-components'
import GeoContext from 'contexts/geoContext'
import Group from 'components/utils/Group'
import { getSVGImageUrl } from 'lib/image/imageUtils'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { selectLoggedIn } from 'selectors/accountSelectors'
import config from 'constants/config'
import GoogleLongLogo from 'components/Common/TrustIndicators/GoogleLongLogo'
import { TrustPilotLogo } from 'components/Common/TrustIndicators/TrustPilotLogo'

const AtolProtectedContainer = styled.div`
  display: none;
  gap: ${rem(4)};

  ${mediaQueryUp.tablet} {
    display: flex;
  }
`

interface Props {
  loggedIn: boolean
}

function NavigationHeaderTrustIndicators({ loggedIn }: Props) {
  const intl = useIntl()
  const { currentRegionCode } = useContext(GeoContext)
  const showTrustIndicators = config.BRAND === 'luxuryescapes' && !loggedIn

  return (
    <Group direction="horizontal" gap={12} verticalAlign="center">
      {currentRegionCode === 'GB' && (
        <AtolProtectedContainer>
          <img src={getSVGImageUrl('984lj4elpskyg828z90qb')} width="16" height="16" alt="" />
          <BodyText variant="small" weight="bold" wrap="no-wrap">{intl.formatMessage({
            id: '0Jcs8eoK5VBiVSZhL7Yd',
            defaultMessage: 'ATOL protected',
            description: 'Trust badge text for ATOL protection in header in the site header',
          })}
          </BodyText>
        </AtolProtectedContainer>
      )}
      {showTrustIndicators && (
        <CSSBreakpoint min="tablet">
          <Group direction="horizontal" gap={12}>
            <Group gap={8} direction="horizontal" verticalAlign="center">
              <GoogleLongLogo width="54" height="18" />
              <BodyText variant="small" weight="bold">{intl.formatMessage({
                id: 'W2l6TxAAMRLBrCBxdb-a',
                defaultMessage: '4.7/5',
                description: 'Google review rating score in header trust indicators',
              })}
              </BodyText>
              <CSSBreakpoint min="desktop">
                <BodyText variant="small" colour="neutral-three" wrap="no-wrap">{intl.formatMessage({
                  id: 'VGDTqGBDx2sBEQrCjFDJ',
                  defaultMessage: '(3K reviews)',
                  description: 'Google review count in header trust indicators in the site header',
                })}
                </BodyText>
              </CSSBreakpoint>
            </Group>
            <Group gap={8} direction="horizontal" verticalAlign="center">
              <div>
                <TrustPilotLogo width="74" height="18" />
              </div>
              <BodyText variant="small" weight="bold" wrap="no-wrap">{intl.formatMessage({
                id: 'gP7O1DPiQmmFq-UimsVY',
                defaultMessage: '4.8/5',
                description: 'TrustPilot review rating score in header trust indicators',
              })}
              </BodyText>
              <CSSBreakpoint min="desktop">
                <BodyText variant="small" colour="neutral-three" align="justify" wrap="no-wrap">{intl.formatMessage({
                  id: 'OMzPoe7P8igOtU2yEO9b',
                  defaultMessage: '(10K reviews)',
                  description: 'TrustPilot review count in header trust indicators',
                })}
                </BodyText>
              </CSSBreakpoint>
            </Group>
          </Group>
        </CSSBreakpoint>
      )}
    </Group>

  )
}

function mapStateToProps(state: App.State) {
  return {
    loggedIn: selectLoggedIn(state),
  }
}

export default connect(mapStateToProps)(NavigationHeaderTrustIndicators)
